import {ExportVideo} from "./components/export";

export const addMedia = () => {
    return (
        <ExportVideo/>);
};
